import React from 'react';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import InfoCard from '../shared/InfoCard';

const { publicRuntimeConfig } = getConfig();

const ContentCarousel = ({ title, description, image, imageDescription }) => {
  const theme = useTheme();
  return (
    <InfoCard
      src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${image?.data?.attributes?.url}`}
      alt={imageDescription}
      title={title}
      description={description}
      textAlign='center'
      titleVariant='subtitle1'
      descriptionVariant='body1'
      style={{
        title: {
          mt: 0,
          p: 0,
          color: theme.palette.primary.textColor3,
          fontSize: {
            textAlign: 'left',
          },
        },
        description: {
          p: 0,
          textAlign: 'left',
          color: theme.palette.primary.textColor3,
        },
      }}
    />
  );
};
export default ContentCarousel;
